// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Plugins
import {
  metalDetectorStatusToText,
  metalDetectorStatusToTagType,
} from '../../../../../../plugins/crusher';

// Hooks
import { useBreakpoint } from '../../../../../../hooks/useBreakpoint';

// Components
import {
  Paragraph,
  ParagraphSize,
  ParagraphWeight,
} from '../../../../../../layout/elements/Paragraph';
import { Tag } from '../../../../../../layout/elements/Tag';

// View
import {
  Container,
  Status,
  StatusContent,
} from './MetalDetector.style';
import { MetalDetectorProps } from './MetalDetector.types';

function MetalDetector({
  className,
  unitData,
  edgeStatus,
  onOpenDrawer,
  testId,
}: MetalDetectorProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();
  const { isXs } = useBreakpoint();

  return (
    <Container
      data-testid={testId}
      className={className}
      onClick={onOpenDrawer}
    >
      <Status>
        <StatusContent>
          <Paragraph
            size={isXs ? ParagraphSize.sm : ParagraphSize.md}
            weight={ParagraphWeight.bold}
          >
            {t('view.crusher.vsi.metalDetector.title')}
          </Paragraph>
          <Tag
            type={metalDetectorStatusToTagType(
              unitData?.metalDetector,
              edgeStatus ? edgeStatus.edgeStatus : null,
              unitData?.timestamp,
            )}
            text={metalDetectorStatusToText(unitData?.metalDetector)}
            testId="metal-detector-status-tag"
          />
        </StatusContent>
      </Status>
    </Container>
  );
}

export { MetalDetector };
